import { render, staticRenderFns } from "./ReportGlobalvalueRecordStore.vue?vue&type=template&id=b1341874&scoped=true&"
import script from "./ReportGlobalvalueRecordStore.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueRecordStore.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueRecordStore.vue?vue&type=style&index=0&id=b1341874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1341874",
  null
  
)

export default component.exports